module.exports = __webpack_public_path__ + "img/ibs logo blanco.ca368e13.png";